@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.promocodes

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.models.RidePromoCodeStatus

object RedeemPromoCodeEndpoint :
    EndPoint<RedeemPromoCodeEndpoint.Request, RedeemPromoCodeEndpoint.Response>() {
    class Request(
        val promoCode: String
    )

    class Response(
        @Suppress("NON_EXPORTABLE_TYPE") val status: DtoName<RidePromoCodeStatus>,
        val amount: Double? = null
    )
}